// seoHeadApi.js
import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

const useSiteMetadata = () => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `
  );
  return site.siteMetadata;
};

const Seo = ({ title, description, lang = "en" }) => {
  const siteMetadata = useSiteMetadata();
  
  const finalTitle = title || siteMetadata.title;
  const finalDescription = description || siteMetadata.description;

  return (
    <>
      <html lang={lang} />
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content="" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
    </>
  );
};

// Export Head to be used in pages
export const Head = ({ title, description, lang = "en" }) => {
  const siteMetadata = useSiteMetadata();

  const finalTitle = title || siteMetadata.title;
  const finalDescription = description || siteMetadata.description;

  return (
    <>
      <html lang={lang} />
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content="" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
    </>
  );
};

export default Seo;